import { useEffect, useState } from 'react'
import { getJson, getUrl } from '../providers/data'
import { OrganizationSettingsOut, TypeConfigField } from '../types/apiRequests'

export type { TypeConfigField }

export type OrganizationSettings = OrganizationSettingsOut

let cachedSettings: OrganizationSettings | null = null
let fetchPromise: Promise<OrganizationSettings | null> | null = null

const fetchSettings = async (): Promise<OrganizationSettings | null> => {
  try {
    return await getJson<OrganizationSettings>(`${getUrl()}/organization_settings`)
  } catch {
    return null
  }
}

export const useOrganizationSettings = () => {
  const [settings, setSettings] = useState<OrganizationSettings | null>(cachedSettings)

  useEffect(() => {
    if (cachedSettings) {
      setSettings(cachedSettings)
      return
    }
    if (!fetchPromise) {
      fetchPromise = fetchSettings()
    }
    void fetchPromise.then((result) => {
      cachedSettings = result
      setSettings(result)
      fetchPromise = null
    })
  }, [])

  return settings
}

export const clearSettingsCache = (): void => {
  cachedSettings = null
  fetchPromise = null
}

export const isZakenOrganization = (settings: OrganizationSettings | null): boolean =>
  settings?.organization_type === 'zaken'
